import z from 'zod'

import { FieldSegmentType, FieldType } from 'common/fields/entities/enums'
import { FilterOperator } from 'common/filter/constants'
import {
  FieldTypeDefaultOperator,
  FieldTypeOperator,
  FilterField,
} from 'common/filter/models/AudienceFilter/constants'

export const filterGroupItemSchema = z.object({
  type: z.union([z.enum(FieldType), z.enum(FieldSegmentType), z.enum(FilterField)]),
  field: z.string(),
  operator: z.union([z.enum(FieldTypeDefaultOperator), z.enum(FieldTypeOperator)]).optional(),
  value: z.string().or(z.number()).optional(),
})

export const betweenDatesConditionValue = z.object({
  from: z.object({ time: z.string() }),
  to: z.object({ time: z.string() }),
  weekdays: z.array(z.string()),
  time_zone: z.string().optional(),
})

export const filterConditionSchema = filterGroupItemSchema.omit({ value: true }).extend({
  _oid: z.string().optional(),
  case_sensitive: z.boolean().optional(),
  is_formula: z.boolean().optional(),
  value: z.string().or(z.number()).or(z.null()).or(betweenDatesConditionValue).optional(),
  offset: z.object({ operator: z.string(), value: z.number() }).nullish(),
  item: z.string().optional(),
})

export const filterDataTypeSchema = z.object({
  operator: z.enum(FilterOperator).optional(),
  groups: z
    .array(
      z.object({
        operator: z.enum(FilterOperator),
        items: z.array(z.union([filterGroupItemSchema, filterConditionSchema])),
      }),
    )
    .optional(),
})

export type FilterDataType = z.infer<typeof filterDataTypeSchema>
export type FilterGroupItem = z.infer<typeof filterGroupItemSchema>
export type FilterCondition = z.infer<typeof filterConditionSchema>
